import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { login } from "../../actions/auth";
import firebase from "../../fire";
import Swal from "sweetalert2";
class Loginform extends Component {
  state = {
    fullname: "",
    email: "",
    password: "",
    cpassword: "",
    error: "",
    isLoading: false,
    showpassword: false,
    role: "user",
  };
  async componentDidUpdate(prevProps, prevState) {
    if (this.props.auth.error !== prevProps.auth.error) {
      const { auth } = this.props;
      this.setState({ isLoading: false });
      await Swal.fire("Login", auth.error.message, "warning");
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { login } = this.props;
    const { email, password } = this.state;
    this.setState({ isLoading: true });
    await login(email, password);
    this.setState({ isLoading: false });
  };



  // onSubmit = async (e) => {
  //   e.preventDefault();
  //   let { email, password } = this.state;
  //   try {
  //     const res = await axios.post(`${Base_url}/auth/login`, {
  //       email,
  //       password,
  //     });
  //     if (res.data.status == "Success") {
  //        await Swal.fire("Login", res.data.message, "success");
  //     }
  //   } catch (err) {
  //     if (err.response) {
  //       const errors = err.response.data.errors;
  //       if (errors) {
  //         // errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
  //       }
  //     }
  //     await Swal.fire("Login", err.response.data.message, "warning");
  //   }
  // };
  render() {
    const { isLoading } = this.state;
    if (
      this.props.AuthLoading === false &&
      this.props.isAuthenticated
    ) {
      return <Redirect to="/dashboard" />;
    }
    if (
      this.props.AuthLoading === false &&
      this.props.isAuthenticated
    ) {
      
        return <Redirect to="/cardInfo" />;
      
    }
    return (
      <div className="row py-5">
        <div className="col-10 col-md-8 m-auto p-4">
          <h4 className="font-weight-bold text-black mb-3">Login</h4>
          <form onSubmit={this.onSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
                className="form-control"
                placeholder="Enter email"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
                className="form-control"
                placeholder="Password"
              />
              {/* <i onClick={()=>{}} className="fa fa-eye"></i> */}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <button
                type="submit"
                className="btn text-white br-15 px-4 hover-shade py-1 bg-sky zoom-in mt-lg-3"
              >
                {isLoading && <i className="mr-1 fa fa-refresh fa-spin"></i>}{" "}
                Login
              </button>

              <Link className="ml-a" to="/forgot-password">
                forgot password?
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  AuthLoading: state.auth.loading,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  login,
})(Loginform);
